import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChildContract } from '@isophi/teachers-shared';
import { ListResponseContract } from '@isophi/teachers-shared';
import { Child } from '@isophi/teachers-shared';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ChildService } from './child.service';
import { GroupService } from './group.service';

@Injectable({
  providedIn: 'root',
})
export class ChildArchiveService {
  public constructor(private httpClient: HttpClient, private childService: ChildService, private groupService: GroupService) {}

  public get archiveGroups$(): Observable<string[]> {
    const url = `${environment.teacherAPI}/archive-groups/`;

    return this.httpClient.get<ListResponseContract<string>>(url).pipe(map((response) => response.results));
  }

  /**
   * Return list of children.
   */
  public children(archiveGroup: string | null = null): Observable<Child[]> {
    const queryParams = `?extra_fields=group_uuids${archiveGroup ? '&archive_group=' + archiveGroup : ''}`;
    const url = `${environment.teacherAPI}/children-archive/${queryParams}`;
    const childrenData$ = this.httpClient.get<ListResponseContract<ChildContract>>(url);

    return combineLatest({
      childrenData: childrenData$,
      groups: this.groupService.groups$,
    }).pipe(
      map((data) => {
        return data.childrenData.results.map((childData) => {
          const child = Child.deserialize(childData);
          this.childService.setChildToGroupsArchive(child, data.groups, childData.group_uuids);
          return child;
        });
      })
    );
  }

  public archiveChildren(children: Child[], archiveGroup: string): Observable<void> {
    const url = `${environment.teacherAPI}/children/bulk-archive/`;
    const data = {
      archive_group: archiveGroup,
      children: children.map((ch) => ch.uuid),
    };

    return this.httpClient.post<void>(url, data);
  }

  public restoreChildrenFromArchive(children: Child[]): Observable<void> {
    const url = `${environment.teacherAPI}/children-archive/bulk-restore/`;
    const data = { children: children.map((ch) => ch.uuid) };

    return this.httpClient.post<void>(url, data);
  }
}
